export default __webpack_public_path__ + "static/media/previousPrice.91d0d3da.svg";